export default "__VITE_ASSET__4488827e__"